module.exports = __webpack_public_path__ + "media/images/shared/delivery/kse-0bf0d6f6f4490d26541ab5e5f2976025.jpg";